<!--START: Skip Link-->
<a
  class="skip-link"
  href="#main-content"
  (click)="skipToMainContent($event)"
  >Skip to main content</a
>
<!--END: Skip Link-->

<!--START: Emulation Banner-->
<app-emulation-banner></app-emulation-banner>
<!--END: Emulation Banner-->

<!--START: Loading Indicator-->
@if (loadingStateService.getAppIsLoading()) {
  <mat-progress-bar
    class="app-loading-bar"
    mode="indeterminate"
    aria-label="Loading"
  ></mat-progress-bar>
  <span class="cdk-visually-hidden" role="status">Loading</span>
}
<!--END: Loading Indicator-->

<!--START: Main Content-->
<mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" opened disableClose fixedInViewport="Fixed">
    <app-navbar></app-navbar>
  </mat-sidenav>
  <mat-sidenav-content>
    <header>
      <app-pagetitle></app-pagetitle>
    </header>
    <main
      id="main-content"
      class="content-container"
      tabindex="-1"
      cdkScrollable
    >
      <router-outlet></router-outlet>
    </main>
    <footer>
      <app-footer></app-footer>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<!--END: Main Content-->

<!--START: Sidepanel Info-->
<router-outlet name="sidepanel-info"></router-outlet>
<!--END: Sidepanel Info-->
